import { getProblemRelatedGraph } from "./ticket_service";

export function createEmptyProblemContext() {
	return {
		related_incidents: [],
		related_changes: [],
		direct_relation_ids: {
			related_incidents: {},
			related_changes: {},
		},
		allowed_transitions: [],
		counts: {
			related_incidents: 0,
			related_changes: 0,
		},
	};
}

export function normalizeProblemRelatedGraph(payload) {
	return {
		related_incidents: Array.isArray(payload?.related_incidents) ? payload.related_incidents : [],
		related_changes: Array.isArray(payload?.related_changes) ? payload.related_changes : [],
		direct_relation_ids: {
			related_incidents: payload?.direct_relation_ids?.related_incidents || {},
			related_changes: payload?.direct_relation_ids?.related_changes || {},
		},
		allowed_transitions: Array.isArray(payload?.allowed_transitions) ? payload.allowed_transitions : [],
		counts: {
			related_incidents: Number(payload?.counts?.related_incidents || 0),
			related_changes: Number(payload?.counts?.related_changes || 0),
		},
	};
}

export async function getProblemContext(problemId) {
	const payload = await getProblemRelatedGraph(problemId);
	return normalizeProblemRelatedGraph(payload);
}
